"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConsiderations = exports.isEqualEvaluations = exports.getEvaluationNamesWithDate = exports.resultStateToString = exports.weakStateToString = exports.progressStateToString = exports.getFileListForSaving = exports.getFileList = exports.checkEvaluationName = exports.getFileNameWithoutPrefix = exports.CONTENT_DOC_NAME = exports.STATE_DOC_NAME = void 0;
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var Config_1 = require("@cck/common/dist/utils/Config");
var lodash_1 = __importDefault(require("lodash"));
exports.STATE_DOC_NAME = '상태';
exports.CONTENT_DOC_NAME = '내역';
function getFileNameWithoutPrefix(evaluationName, controlId, filename) {
    var prefix = "(".concat(evaluationName, ")(").concat(controlId, ")(\uC99D\uBE59)");
    if (lodash_1.default.startsWith(filename, prefix)) {
        return lodash_1.default.replace(filename, prefix, '');
    }
    return filename;
}
exports.getFileNameWithoutPrefix = getFileNameWithoutPrefix;
function readFileNameGroup(name, start) {
    if (name[start] !== '(')
        return undefined;
    var depth = 0;
    for (var index = start; index < name.length; index += 1) {
        if (name[index] === '(')
            depth += 1;
        if (name[index] === ')')
            depth -= 1;
        if (depth === 0) {
            return { value: name.slice(start + 1, index), end: index + 1 };
        }
    }
    return undefined;
}
function checkEvaluationName(fileName, targetEvaluationName) {
    var normalized = fileName.normalize('NFC');
    if (normalized[0] !== '(')
        return undefined;
    var evaluationEnds = [];
    for (var evaluationEnd = normalized.indexOf(')('); evaluationEnd !== -1; evaluationEnd = normalized.indexOf(')(', evaluationEnd + 1)) {
        evaluationEnds.push(evaluationEnd);
    }
    var parseAt = function (evaluationEnd, controlFirst) {
        var first = readFileNameGroup(normalized, evaluationEnd + 1);
        if (!first)
            return undefined;
        var second = readFileNameGroup(normalized, first.end);
        if (!second)
            return undefined;
        var fileType = controlFirst ? second.value : first.value;
        if (!lodash_1.default.includes(Object.values(BaseFile_1.FileType), fileType))
            return undefined;
        return {
            evaluationName: lodash_1.default.trim(normalized.slice(1, evaluationEnd)),
            controlId: lodash_1.default.trim(controlFirst ? first.value : second.value),
            fileType: fileType,
            name: lodash_1.default.trim(normalized.slice(second.end))
        };
    };
    // 평가명에 구분자처럼 보이는 문자열이 있으면 현재 평가명으로 경계를 확정한다.
    // target은 경계 선택에만 쓰고 반환값/일치 검사는 원본 파일명 기준으로 유지한다.
    if (targetEvaluationName !== undefined) {
        var target_1 = lodash_1.default.trim(targetEvaluationName.normalize('NFC'));
        var targetEnd = evaluationEnds.find(function (end) { return lodash_1.default.trim(normalized.slice(1, end)) === target_1; });
        if (targetEnd !== undefined) {
            var matched = parseAt(targetEnd, true) || parseAt(targetEnd, false);
            if (matched)
                return matched;
        }
    }
    // 문맥이 없으면 균형 있는 평가명의 외곽을 우선해 뒤 파일명을 보존한다.
    var evaluation = readFileNameGroup(normalized, 0);
    if (evaluation) {
        var matched = parseAt(evaluation.end - 1, true) || parseAt(evaluation.end - 1, false);
        if (matched)
            return matched;
    }
    // 짝 없는 평가명은 기존의 오른쪽 경계·통제→종류 순서 우선 규칙으로 읽는다.
    for (var _i = 0, _a = [true, false]; _i < _a.length; _i++) {
        var controlFirst = _a[_i];
        for (var index = evaluationEnds.length - 1; index >= 0; index -= 1) {
            var matched = parseAt(evaluationEnds[index], controlFirst);
            if (matched)
                return matched;
        }
    }
    return undefined;
}
exports.checkEvaluationName = checkEvaluationName;
function compareFileName(file) {
    var _a;
    var nameNumber = (_a = checkEvaluationName(file.name, file.evaluationName)) === null || _a === void 0 ? void 0 : _a.name.match(/^\d+/);
    if (nameNumber) {
        return lodash_1.default.parseInt(nameNumber[0]);
    }
}
function getFileList(evaluation) {
    var _a, _b, _c, _d, _e;
    var files = [];
    if (!lodash_1.default.isEmpty((_b = (_a = evaluation.content.files) === null || _a === void 0 ? void 0 : _a.record) === null || _b === void 0 ? void 0 : _b.name)) {
        files.push(evaluation.content.files.record);
    }
    if (((_c = evaluation.content.files) === null || _c === void 0 ? void 0 : _c.population) &&
        !lodash_1.default.isEmpty((_e = (_d = evaluation.content.files) === null || _d === void 0 ? void 0 : _d.population) === null || _e === void 0 ? void 0 : _e.name)) {
        files.push(evaluation.content.files.population);
    }
    lodash_1.default.forEach(lodash_1.default.sortBy(evaluation.content.files.evidence, [compareFileName, function (file) { return file.name; }]), function (evidence) { return files.push(evidence); });
    lodash_1.default.forEach(lodash_1.default.sortBy(evaluation.content.files.extra, [compareFileName, function (file) { return file.name; }]), function (extra) { return files.push(extra); });
    return files;
}
exports.getFileList = getFileList;
function getFileListForSaving(evaluationItem, files) {
    var deletedFiles = (0, lodash_1.default)(getFileList(evaluationItem))
        .map(function (savedFile) { return (!lodash_1.default.find(files, { name: savedFile.name }) ? savedFile : undefined); })
        .compact()
        .value();
    var newFiles = (0, lodash_1.default)(files)
        .map(function (file) {
        return lodash_1.default.includes([BaseFile_1.FileState.OK, BaseFile_1.FileState.ALREADY_EXISTING], file.state) ? file : undefined;
    })
        .compact()
        .value();
    return { deletedFiles: deletedFiles, newFiles: newFiles };
}
exports.getFileListForSaving = getFileListForSaving;
function progressStateToString(state) {
    if (state === Evaluation.ProgressState.Performing) {
        return '수행중';
    }
    else if (state === Evaluation.ProgressState.Performed) {
        return '수행완료';
    }
    else if (state === Evaluation.ProgressState.Rejected) {
        return '재작성 필요';
    }
    else if (state === Evaluation.ProgressState.Approved) {
        return '승인완료';
    }
    return '미수행';
}
exports.progressStateToString = progressStateToString;
function weakStateToString(type, state) {
    if (type === Evaluation.Type.Operation) {
        if (state === Evaluation.OperationWeakState.Pending) {
            return '평가 대기';
        }
        else if (state === Evaluation.OperationWeakState.Deficiency) {
            return '단순한 미비점';
        }
        else if (state === Evaluation.OperationWeakState.SignificantDeficiency) {
            return '유의한 미비점';
        }
        else if (state === Evaluation.OperationWeakState.MaterialWeakness) {
            return '중요한 취약점';
        }
        return '평가 대상 아님';
    }
    if (state === Evaluation.DesignWeakState.Pending) {
        return '평가 대기';
    }
    else if (state === Evaluation.DesignWeakState.Done) {
        return '작성완료(반영할 수정사항 없음)';
    }
    else if (state === Evaluation.DesignWeakState.Modification) {
        return '작성완료(반영할 수정사항 있음)';
    }
    return '평가 대상 아님';
}
exports.weakStateToString = weakStateToString;
function resultStateToString(state) {
    if (state === Evaluation.ResultState.Normal) {
        return '미비사항 없음';
    }
    else if (state === Evaluation.ResultState.Defect) {
        return '미비사항 존재';
    }
    return '평가 결론 없음';
}
exports.resultStateToString = resultStateToString;
function getEvaluationNamesWithDate(bases) {
    return lodash_1.default.map(bases, function (base) { return "".concat(base.name, " (").concat(base.period, ")"); });
}
exports.getEvaluationNamesWithDate = getEvaluationNamesWithDate;
function compareEvaluation(aList, bList) {
    if (!aList || !bList || aList.length !== bList.length)
        return false;
    return lodash_1.default.every(lodash_1.default.zip(aList, bList), function (_a) {
        var a = _a[0], b = _a[1];
        return (a.type === b.type &&
            a.base.name === b.base.name &&
            a.controlId === b.controlId &&
            lodash_1.default.isEqual(a.content.files, b.content.files) &&
            a.state.state === b.state.state &&
            a.state.weakState === b.state.weakState &&
            lodash_1.default.isEqual(a.content.data, b.content.data));
    });
}
function isEqualEvaluations(aList, bList) {
    return lodash_1.default.isEqualWith(aList, bList, compareEvaluation);
}
exports.isEqualEvaluations = isEqualEvaluations;
function getConsiderations() {
    var considerations = [];
    if ((0, Config_1.getProjectId)() !== 'icfr-tmon' && (0, Config_1.getProjectId)() !== 'icfr-meerecompany') {
        considerations.push({
            title: '통제 목적의 적절성 및 위험평가에서 인식된 위험/경영진의 주장과의 연관성',
            content: '통제목적(파악된 Risk & 경영진의 주장)에 통제활동이 부합하는가? (실제 Risk를 감소시키는가?)'
        });
        considerations.push({
            title: '통제활동이 수행되는 기간, 빈도 및 일관성',
            content: '통제가 적용된 기간은 전체기간에 적용되었는가? (통제가 설계되어 수행된 기간은 충분한지)\n' +
                '통제 수행 빈도는 적정한가? (통제 수행 빈도가 위험을 적시에 예방하거나 적발할 수 있는지)\n' +
                '통제가 수행되는 빈도는 통제기간 동안 일관되게 적용되었는가?'
        });
        considerations.push({
            title: '통제 수행 수준 및 예측가능성',
            content: '통제활동 수행의 세부항목/수준 혹은 예측기준 설정 방안은 충분한가?'
        });
        considerations.push({
            title: '통제에 사용되는 정보의 신뢰성 확보',
            content: '통제수행에 필요한 정보의 신뢰성 확보 방안은 적절히 설계되었는가?'
        });
        considerations.push({
            title: '예외사항 발생시 대응',
            content: '통제 수행 중에 발생하는 예외사항에 대한 추가 절차는 충분한가?'
        });
    }
    else {
        considerations.push({
            title: '설계된 통제가 관련 “what could go wrong”을 다루고 대응하는 목적을 충족하는지',
            content: '관련 계정과목과 경영진주장의 중요한 왜곡표시위험에 충분히 대처하는지 평가한다.'
        });
        considerations.push({
            title: '통제수행자가 해당 통제의 목적에 적합한 적격성과 권한을 지녔는지?',
            content: '통제수행자가 적절한 지식, 적격성과 권한을 보유하고 있는 것을 입증할 수 있는' +
                ' 증거가 무엇인지 평가한다.'
        });
        considerations.push({
            title: '이상항목들을 적시에 식별하고 조사하고 해결하기에 통제의 수행 빈도가 왜 충분한지?',
            content: '통제가 이상항목을 적시에 식별, 조사 그리고 해결할 수 있는 충분한 빈도로' +
                ' 수행되고 있다는 증거가 무엇인지 평가한다.(실제 재무제표에 중요한' +
                ' 영향을 미치기 전에 왜곡표시를 예방 또는 적발 할 수 있는 빈도인지?)'
        });
    }
    return considerations;
}
exports.getConsiderations = getConsiderations;
//# sourceMappingURL=EvaluationUtils.js.map